export const confirmationText = {
  confirmationRequired:
    'You are about to make changes to records which could affect the related records of your system. Please confirm that you want to proceed with the changes.',
  willSendEmails: 'Are you sure you want to send emails?',
  willNotSendEmails: "Are you sure you don't want to send emails?",
}
